import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Write from "./pages/Write";
import Discover from "./pages/Discover";
import Profile from "./pages/Profile";
import Bookmarks from "./pages/Bookmarks";
import Admin from "./pages/Admin";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/write" element={<Write />} />
      <Route path="/discover" element={<Discover />} />
      <Route path="/profile/:username" element={<Profile />} />
      <Route path="/bookmarks" element={<Bookmarks />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}